export const ordinalSuffix = (value: number): string => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  // The teens all take 'th', so shift them out of the lookup before indexing.
  const remainder = value % 100;
  return value + (suffixes[(remainder - 20) % 10] || suffixes[remainder] || suffixes[0]);
};
